import { createFileRoute } from "@tanstack/react-router";
import { ConversationDetailPage } from "@/features/conversations/conversation-detail-page";

export const Route = createFileRoute("/_authenticated/conversations/$conversationId")({
  head: () => ({ meta: [{ title: "Conversation · Rogue Admin" }] }),
  component: ConversationDetailPage,
});
